import React from "react";
import { Network } from 'lucide-react';
import { NavItem } from "../NavItem";

export function MSBbLink({ isCollapsed }) {
    return (
        <NavItem
            redirectUrl="/msb"
            Icon={Network}
            label="Baseline Rules"
            isCollapsed={isCollapsed}
        />
    );
}
